<template>
  <div class="attendance-nav-panel">
    <div class="title" v-if="title">
      <h1>{{ $t(title) }}</h1>
      <hr />
    </div>

    <slot></slot>
  </div>
</template>

<script>
import Icon from '@/components/togo/icon';

const AttendanceNavPanel = {
  name: 'AttendanceNavPanel',

  props: {
    title: {
      type: String
    }
  },

  components: {
    Icon
  }
};

export default AttendanceNavPanel;
</script>

<style lang="sass">
  @import 'src/scss/variables'
  @import 'src/scss/mixins'

  .attendance-nav-panel
    position: relative
    display: flex
    flex-direction: column
    overflow: auto

    padding: 20px
    @include layout-horizontal
      padding: 30px
      min-width: 350px
      max-width: 350px
      border-right: 1px solid #cecdcd

    .title
      hr
        margin-left: -30px
        margin-right: -30px
        border-top: none
        border-bottom: 1px solid #cecdcd

      @include layout-vertical
        display: none

    h1
      font-size: 18px
      font-weight: bold
      font-style: normal
      font-stretch: normal
      line-height: 1.22
      letter-spacing: 0.7px
      color: #4a4a4a
      text-transform: uppercase
</style>
